{
    "home.title": "Mis Tiendas",
    "home.store.openTasks": "Tareas Abiertas",
    "home.stores.title": "Inicio",
    "home.noMobileAccess.title": "Esta cuenta no tiene acceso a la aplicación Badger Mobile.",
    "home.noMobileAccess.body": "Contacte a su gerente para solicitar acceso.",
    "home.noHomeStore.message": "No tiene una tienda principal configurada. Por favor contacte a su gerente.",
    "home.myStores.title": "Mis Tiendas",
    "home.myStores.link": "Tiendas",
    "home.label.edit": "Mis Tiendas",

    "tasks.label": "Tareas",
    "tasks.store.allTasks": "Todas las Tareas",
    "tasks.filters.allTaskTypes": "Todos los Tipos de Tareas",
    "tasks.filters.allResolutionTypes": "Todos los Tipos de Resolución",
    "tasks.store.idLabel": "ID de Tienda",
    "tasks.store.outOfStock": "Agotado",
    "tasks.store.wrong": "Incorrecto",
    "tasks.store.price": "Precio",
    "tasks.store.salePrice": "Precio de Oferta",
    "tasks.store.taskMap": "Mapa de Tareas",
    "tasks.allAisles": "Todos los Pasillos",
    "tasks.supress.message": "Esta tarea se pospondrá durante 7 días.",
    "tasks.list.completeTask": "Completar Tarea",
    "tasks.list.flagTask": "Marcar Tarea",
    "tasks.store": "Tienda",
    "tasks.aisles": "Pasillos",
    "tasks.complete.message": "Tarea completada con éxito.",
    "tasks.error.message": "Algo salió mal al completar la tarea.",
    "tasks.general.message": "No se pudo completar la tarea.",

    "profile.title": "Perfil",
    "profile.name.label": "Nombre",
    "profile.email.label": "Correo electrónico",
    "profile.organization.label": "Organización",
    "profile.homeStore.label": "Tienda Principal",
    "profile.role.label": "Rol",
    "profile.roles.label": "Roles",

    "general.label.today": "Hoy",
    "general.label.search": "Buscar",
    "general.label.comment": "Comentario",
    "general.label.comments": "Comentarios",
    "general.label.resolved": "Resuelto",
    "general.label.new": "Nuevo",
    "general.label.edit": "Editar",
    "general.label.signOut": "Cerrar sesión",
    "general.label.actionable": "Accionable",
    "general.action.save": "Guardar",
    "general.action.cancel": "Cancelar",
    "general.action.close": "Cerrar",
    "general.action.snooze": "Posponer",
    "general.action.create": "Crear",
    "general.home.title": "Inicio",
    "general.tasks.title": "Tareas",
    "general.users.title": "Perfil",
    "general.rfid.title": "RFID",
    "general.label.products": "Productos",
    "general.action.prev": "Ant.",
    "general.action.next": "Siguiente",
    "general.label.gtin": "GTIN",
    "general.label.all": "Todos",

    "sort.label.taskCount": "Cantidad de Tareas",
    "sort.label.aisleName": "Nombre del Pasillo",
    "sort.label.aisleLocation": "Ubicación del Pasillo",
    "sort.label.shelfLocation": "Ubicación del Estante",
    "sort.label.taskType": "Tipo de Tarea",
    "sort.label.productName": "Nombre del Producto",
    "sort.label.sku": "SKU",
    "sort.label.recurrenceCount": "Cantidad de Recurrencias",
    "sort.label.tagCount": "Cantidad de etiquetas",

    "task.type.price": "Precio",
    "task.type.salePrice": "Precio de Oferta",
    "task.type.outOfStock": "Agotado",
    "task.type.wrong": "Artículo Incorrecto",

    "task.resolution.autoResolved": "Resuelto Automáticamente",
    "task.resolution.completed": "Completado",
    "task.resolution.flagged": "Marcado",
    "task.resolution.not a problem": "No se encontraron problemas",
    "task.resolution.no stock found": "No se encontró stock para reabastecer",

    "task.status.active": "Activo",
    "task.status.completed": "Resuelto",
    "task.status.suppressed": "Pospuesto",
    "task.status.expired": "Expirado",

    "tasks.paths.label": "Pasillos",

    "validation.error.required": "Este campo es obligatorio",
    "validation.error.minLength": "La longitud mínima es de {{length}} caracteres",

    "user.label.email": "Correo electrónico",
    "user.label.email.placeholder": "Correo electrónico",
    "user.label.email.error": "Correo electrónico requerido",
    "user.label.email.invalid": "Formato de correo electrónico inválido",
    "user.label.firstName": "Nombre",
    "user.label.firstName.placeholder": "Nombre",
    "user.label.firstName.error": "Nombre requerido",
    "user.label.lastName": "Apellido",
    "user.label.lastName.placeholder": "Apellido",
    "user.label.lastName.error": "Apellido requerido",
    "user.label.organization": "Organización",
    "user.label.homeStore": "Tienda principal",
    "user.label.homeStore.placeholder": "Buscar tiendas principales",
    "user.label.homeStore.noFound": "No se encontraron tiendas principales",
    "user.label.allowedStores": "Tiendas permitidas",
    "user.select.store.placeholder": "Buscar tiendas",
    "user.select.store.noFound": "No se encontraron tiendas",
    "user.label.roles": "Roles",

    "rfid.label.tag": "Etiqueta RFID",
    "rfid.label.allZones": "Todas las zonas",
    "rfid.label.serial": "Número de serie",
    "rfid.label.epc": "EPC",
    "rfid.label.zone": "Zona",
    "rfid.label.date": "Fecha",
    "rfid.label.nonLocalized": "No localizado",

    "signOut.success": "Tu sesión ha finalizado. Por favor, inicia sesión para acceder a tu cuenta.",
    "signOut.error": "Ocurrió un error al cerrar la sesión. Por favor, inténtalo de nuevo."
}
